import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Modal, TextField } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import * as yup from "yup";
import CommonButton from "../../../common/components/Buttons/CommonButton";
import InputField from "../../../common/components/FormFields/InputField";
import { CloseModalIcon } from "../../../common/components/assets/commonassets/CommonAssets";
import CommonBackDrop from "../../../common/components/CommonBackDrop/CommonBackDrop";
import {
    errorAlert,
    successAlert,
} from "../../../common/components/Toasts/CustomToasts";
import React, { useState } from "react";
import { saveTemplateMaster } from "../../services/emrTemplateServices/EMRTemplateServices";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 2,
    borderRadius: "8px",
};

const schema = yup.object().shape({
    templateName: yup.string().trim().required("Template name is required"),

    dietExercise: yup.string().trim().required("Template name is required"),
});

const DietExerciseModal = ({
    openModal,
    setOpenModal,
    selectedId,
    selectedRow,
    selectedFieldId,
    setSelectedFieldId,
    templateValue,
    setTemplateValue,
    getGeneralExaminations,
}) => {
    const {
        control,
        handleSubmit,
        setValue,
        reset,
        watch,
        formState: { errors },
    } = useForm({
        defaultValues: {
            dietExercise: "",
            templateName: ""
        },
        resolver: yupResolver(schema),
    });


    //   const getUserInfo = JSON.parse(localStorage?.getItem("loggedUser"));
    const getdietExercise = watch("dietExercise");

    const templateName = watch("templateName");
    const [openBackDrop, setOpenBackdrop] = useState(false);
    const onSubmit = (data) => {
        if (!data?.templateName?.trim()) {
            errorAlert("Please Add Template Name !")
            return;
        }
        const obj = {
            templateName: templateName,
            templateFieldId: selectedFieldId ? selectedFieldId : null,
            description:
                getdietExercise
                    ? getdietExercise
                    : "",

            doctorId: selectedRow?.["Doctor Id"] ? selectedRow?.["Doctor Id"] : null,
            // id: selectedId !== null ? selectedId : null,
            id: null,

        };
        setOpenBackdrop(true);

        console.log(obj, "obj");
        saveTemplateMaster(obj)
            .then((response) => response.data)
            .then((res) => {
                if (res.statusCode === 201 || res.statusCode === 200) {
                    setOpenModal(false);
                    // populateTable();
                    setTemplateValue("")
                    successAlert(res?.message);
                    reset();
                    setOpenBackdrop(false);
                    setSelectedFieldId(null);
                }
            })
            .catch((error) => {
                // console.log("error", error);
                setOpenModal(false);
                errorAlert(error?.message);
                setOpenBackdrop(false);
            });
    };

    React.useEffect(() => {

        if (openModal) {
            setValue("dietExercise", templateValue || "")
        }
        console.log("templateValuetemplateValuetemplateValuetemplateValue", templateValue);


    }, [templateValue, openModal])
    return (
        <Modal open={openModal}>
            <Box sx={style}>
                <div className="flex justify-between items-center mb-2">
                    <h2 className="font-semibold">Diet & Exercise Template</h2>

                    <div
                        className="cursor-pointer"
                        onClick={() => {
                            reset();
                            setOpenModal(false);
                            setSelectedFieldId(null);
                        }}
                    >
                        <CloseModalIcon />
                    </div>
                </div>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className={"py-3"}>
                        <InputField
                            label="Template Name"

                            name="templateName"
                            control={control}
                            error={errors.templateName}
                        />
                    </div>

                    {/* <InputField
            label="HOPI"
            name="hopi"
            control={control}
            error={errors.hopi}
          /> */}
                    <Controller
                        name="dietExercise"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                            <TextField
                                {...field}
                                label="Description"
                                multiline
                                rows={6}
                                fullWidth
                                variant="outlined"
                                error={!!errors.dietExercise}
                                helperText={errors.dietExercise?.message}
                            />
                        )}
                    />

                    <div className="flex justify-end gap-2 pt-4">
                        <CommonButton
                            label="Reset"
                            type="button"
                            onClick={() => reset()}
                            className="resetButton px-6  border border-red-500 text-red-500"
                        />

                        <CommonButton
                            label="Save"
                            type="submit"
                            className="px-6  bg-green-700 text-white "
                        />
                    </div>
                    {openBackDrop && <CommonBackDrop openBackdrop={openBackDrop} />}
                </form>
            </Box>
        </Modal>
    );
};

export default DietExerciseModal;


